<template>
  <v-form ref="USER" lazy-validation @submit.prevent="save">
    <div>
      <section-header
          v-if="!hideTitle"
          ref="USER"
          :ressource="ressource"
          :is-extended="extended"
          :dialog="dialog"
          :picto="picto()"
          @extended=setExtended
          @close-dialog=closeDialog>
      </section-header>
      <div v-if="extended" id="field-container" :class="dialog ? 'p-0 p-md-3' : 'py-2'">
        <check-field v-if="isDisplayed('CI98')"
                     ref="CI98"
                     :value=ci98
                     :context-id=user.id
                     :edit-field-info=checkFieldCi98
                     :required="isRequired('CI98')"
                     :disabled="readOnly('CI98')"
                     :show-missing="false"
                     @updated=setCi98>
        </check-field>
        <user-client98 v-if="isDisplayed('CLIENT98')"
                   ref="CLIENT98"
                   v-model:value=client98
                   :theme="theme"
                   :show-missing="false"
                   :required="isRequired('CLIENT98')"
                   :context-id=user.id
                   :read-only="readOnly('CLIENT98')"
                   :obj-type=objType
                   :fiche=fiche
                   :section-name="sectionName"
                   @status=statusClient98>
        </user-client98>
        <user-prenom v-if="isDisplayed('PRENOM')"
                     ref="PRENOM"
                     v-model:value=prenom
                     :theme="theme"
                     :show-missing="showMissing"
                     :min="3"
                     :max="25"
                     :required="isRequired('PRENOM')"
                     :context-id=user.id
                     :read-only="readOnly('PRENOM')"
                     :obj-type=objType
                     :fiche=fiche
                     :section-name="sectionName"
                     @status=statusPrenom>
        </user-prenom>
        <user-nom v-if="isDisplayed('NOM')"
                  ref="NOM"
                  v-model:value=nom
                  :theme="theme"
                  :show-missing="showMissing"
                  :min="3"
                  :max="25"
                  :required="isRequired('NOM')"
                  :context-id=user.id
                  :read-only="readOnly('NOM')"
                  :obj-type=objType
                  :fiche=fiche
                  :section-name="sectionName"
                  @status=statusNom>
        </user-nom>
        <user-mail v-if="isDisplayed('MAIL')"
                   ref="MAIL"
                   v-model:value=mail
                   :theme="theme"
                   :show-missing="showMissing"
                   :required="isRequired('MAIL')"
                   :context-id=user.id
                   :read-only="readOnly('MAIL')"
                   :obj-type=objType
                   :fiche=fiche
                   :section-name="sectionName"
                   @status=statusMail>
        </user-mail>
        <user-numero v-if="isDisplayed('NUMERO')"
                     ref="NUMERO"
                     v-model:value=numero
                     :theme="theme"
                     :show-missing="showMissing"
                     :required="isRequired('NUMERO')"
                     :context-id=user.id
                     :read-only="readOnly('NUMERO')"
                     :section-name="sectionName">
        </user-numero>
        <div v-for="(profile, index) in profiles" :key="index">
          <check-field ref=profile
                       :value=getProfile(profile)
                       :context-id="user.id"
                       :edit-field-info=checkFieldProfile(profile)
                       @updated="(value) => setProfile(profile, value)">
          </check-field>
        </div>
      </div>
    </div>
    <div v-if="extended" class="d-flex flex-row-reverse">
      <loader-button
          v-if="saveButton"
          class="ms-2"
          type="submit"
          :label="saveLabel"
          :loading="saveLoading"
          :disabled="!updatedAndValid">
      </loader-button>
      <loader-button
          v-if="existUser"
          class="ms-2"
          type="button"
          :outlined="true"
          :label="loginBtnTxt"
          @callback="sudo">
      </loader-button>
    </div>
    <div v-if="saveFailed && saveButton && extended" class="d-flex flex-row-reverse">
      <p class="text-12 text-bold error-text">{{ errorTxt }}</p>
    </div>
  </v-form>
</template>

<script lang="ts">
import CrudUser from '@/generated/cruds/CrudUser';
import {GenSection, RessourceGenSection} from '@/generated/ressources/generatedRessources';
import {FwkButtons, RessourceFwkButton, RessourceFwkSection, FwkSections} from '@/ressources/globalRessources';
import {Sections} from '@/generated/classes/AppSchema';
import {storeSession} from '@/generated/stores';
import UserProfile, {EnumProfile} from "@/framework/base/classes/UserProfile";
import {FieldStatus, EditFieldType, FieldInfo} from '@/framework/base/components/FieldInfo';
import EditField from '@/framework/base/components/EditField.vue';
import CheckField from "@/framework/base/components/CheckField.vue";
import {MapRessource} from '@/framework/base/helpers/Ressources';
import Ressource from '@/framework/ressource/classes/Ressource';
import {defineComponent} from "vue";
import {useRouter} from "vue-router";

export default defineComponent({
  components: {
    EditField,
    CheckField
  },
  extends: CrudUser,
  props: {
    hideTitle: {
      type: Boolean
    }
  },
  data() {
    return {
      sectionName: Sections.USER,
      initProfil: 0,
      ci98: false,
      router: useRouter()
    };
  },
  created() {
    this.initProfil = this.user.profil;
    this.ci98 = this.user.client98 > 0
  },

 computed: {
    saveLabel() {
      return RessourceFwkButton(FwkButtons.ENREGISTRER).label;
    },
    errorTxt() {
      return RessourceFwkSection(FwkSections.ERROR_TEXT).label;
    },
    ressource() {
      return RessourceGenSection(GenSection.USER);
    },
    loginBtnTxt() {
      return RessourceFwkButton(FwkButtons.LOGIN).label;
    },
    existUser() {
      return this.editUser.id > 0;
    },
    profiles(): EnumProfile[] {
      const profiles: EnumProfile[] = [];
      if (this.editUser.clientId <= 0 && !this.ci98) {
        profiles.push(EnumProfile.admin);
        profiles.push(EnumProfile.support);
        profiles.push(EnumProfile.marketing);
        profiles.push(EnumProfile.compta);
      }
      return profiles;
    },
    saveButton(): boolean {
      return this.editUser.clientId == 0 || this.editUser.id <= 0;
    },
    admin(): boolean {
      const user = storeSession.connectedUser;
      if (user) {
        return UserProfile.hasProfile(user, EnumProfile.admin) || UserProfile.hasProfile(user, EnumProfile.superAdmin)
      } else {
        return false
      }
    },
    fields(): string[] {
      return ['PRENOM', 'NOM', 'MAIL', 'NUMERO', 'CLIENT98', 'CI98'];
    },
    checkFieldCi98(): FieldInfo {
      const ressource = new Ressource();
      ressource.label = 'CI98';
      const type = EditFieldType.BOOL;
      const precision = 0;
      const format = null;
      const mask = null;
      const focus = null;
      const live = null;
      return new FieldInfo(ressource, type, precision, mask, format, focus, live);
    }
  },
  methods: {
    mask(value: string): string {
      return '';
    },
    getFieldInfo(): FieldInfo {
      const ressource = new MapRessource();
      ressource.label = 'Numéro de client';
      ressource.placeholder = 'Numéro';
      const type = EditFieldType.INT;
      const precision = 2;
      const format = null;
      return new FieldInfo(ressource, type, precision, this.mask, format, null, null);
    },
    getClient(): string {
      return this.editUser.clientId.toString();
    },
    setClient(value: string) {
      this.editUser.clientId = parseInt(value);
    },
    setCi98(value: boolean) {
      this.ci98 = value;
      if (!value) {
        this.client98 = '0';
      }
      this.statusClient98(new FieldStatus(false, value != (this.user.client98 > 0), 0));
    },
    checkFieldProfile(profile: EnumProfile): FieldInfo {
      const ressource = new Ressource();
      ressource.label = EnumProfile[profile].toString();
      const type = EditFieldType.BOOL;
      const precision = 0;
      const format = null;
      const mask = null;
      const focus = null;
      const live = null;
      return new FieldInfo(ressource, type, precision, mask, format, focus, live);
    },
    getProfile(profile: EnumProfile): boolean {
      return (this.editUser.profil & profile) > 0;
    },
    setProfile(profile: EnumProfile, value: boolean) {
      if (value && (this.editUser.profil & profile) == 0) {
        this.editUser.profil += profile
      } else if ((this.editUser.profil & profile) == profile) {
        this.editUser.profil -= profile;
      }
      this.statusProfil(new FieldStatus(this.editUser.profil == 0, this.editUser.profil != this.initProfil, 0));
    },
    readOnly(value: string): boolean {
      let res = false;
      if (value == 'PRENOM') {
        res = this.editUser.id > 0;
      } else if (value == 'NOM') {
        res = this.editUser.id > 0;
      } else if (value == 'MAIL') {
        res = this.editUser.id > 0;
      } else if (value == 'NUMERO') {
        res = this.editUser.id > 0;
      } else if (value == 'CLIENT98') {
        res = this.editUser.id > 0;
      } else if (value == 'CI98') {
        res = this.editUser.id > 0;
      }
      return res;
    },
    isDisplayed(value: string): boolean {
      let res = false;
      if (value == 'PRENOM') {
        res = true;
      } else if (value == 'NOM') {
        res = true;
      } else if (value == 'MAIL') {
        res = true;
      } else if (value == 'NUMERO') {
        res = true;
      } else if (value == 'CLIENT98') {
        res = this.ci98 || this.editUser.clientId > 0;
      } else if (value == 'CI98') {
        res = this.editUser.id <= 0 || this.ci98;
      }
      return res;
    },
    isRequired(value: string): boolean {
      let res = false;
      if (value == 'PRENOM') {
        res = true;
      } else if (value == 'NOM') {
        res = true;
      } else if (value == 'MAIL') {
        res = true;
      } else if (value == 'NUMERO') {
        res = false;
      } else if (value == 'CLIENT98') {
        res = false;
      } else if (value == 'CI98') {
        res = true;
      }
      return res;
    },
    picto(): string {
      return 'SectionPictoUser'
    },
    clientMissing(): boolean {
      // @ts-expect-error : generated method
      return this.$refs.CLIENT98.missing();
    },
    sudo() {
      const adminNom = storeSession.connectedUser?.nom ?? '';
      const adminPrenom = storeSession.connectedUser?.prenom ?? '';
      storeSession.sudo(this.editUser.id).then((res) => {
        if (res) {
          sessionStorage.setItem('resynchSudoAdminNom', adminNom);
          sessionStorage.setItem('resynchSudoAdminPrenom', adminPrenom);
          sessionStorage.setItem('resynchSudoToken', storeSession.httpToken);
          this.router.push({name: 'Dashboard'});
          setTimeout(() => window.location.reload(), 1000)
        }
      })
    }
  }
})

</script>
